import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { orderStore } from "./order-store";
import backendApi from "../apis/backend-api";

const allMenuStore = new Vuex.Store({
  state: {
    allMenuList: {},
    statusListPosting: [],
    statusListPostingAndPrint: [],
    statusListOrikomi: [],
    statusListGeenie: [],
    demographicsLists: [],
    daysLists: [],
    hoursLists: [],
    osLists: [],
    findPostingAndPrintStatusJName: [
      {
        name_j: "全配布ステータス",
        id: -1,
      },
      {
        name_j: "印刷データ承認前",
        id: 0,
      },
      {
        name_j: "印刷データ確認中",
        id: 1,
      },
      {
        name_j: "印刷データ承認済",
        id: 2,
      },
      {
        name_j: "印刷中",
        id: 3,
      },
      {
        name_j: "発送済",
        id: 4,
      },
      {
        name_j: "到着済",
        id: 5,
      },
      {
        name_j: "原稿審査承認NG",
        id: 6,
      },
      {
        name_j: "キャンセル",
        id: 7,
      },
    ],
  },
  mutations: {
    async updateStatusListPosting(state) {
      const status = await backendApi.orderStatusListPosting();
      state.statusListPosting = status.value.posting_status_list;
      state.statusListPostingAndPrint = status.value.printing_status_list;
    },
    async updateStatusListOrikomi(state) {
      const status = await backendApi.orderStatusListOrikomi();
      state.statusListOrikomi = status.value.status_list;
    },
    async updateStatusListGeenie(state) {
      const status = await backendApi.orderStatusListGeenie();
      state.statusListGeenie = status.value.status_list;
    },
    async callGeenieLists(state) {
      const demo = await backendApi.demographicsGeenie();
      const hours = await backendApi.hoursGeenie();
      const days = await backendApi.daysGeenie();
      const os = await backendApi.osGeenie();
      state.demographicsLists = demo.value;
      state.osLists = os.value;
      state.hoursLists = hours.value;
      state.daysLists = days.value;
    },
    updateAllMenuList(state, allMenuList) {
      state.allMenuList = allMenuList;
    },
  },
  getters: {
    findPaperSizeJName: (state) => (name) => {
      if (!state.allMenuList.paper_sizes) {
        return "";
      }
      for (let i = 0; i < state.allMenuList.paper_sizes.options.length; i++) {
        if (state.allMenuList.paper_sizes.options[i].name == name) {
          return state.allMenuList.paper_sizes.options[i].name_j;
        }
      }
      return "";
    },
    findColorTypeJName: (state) => (name) => {
      if (!state.allMenuList.color_types) {
        return "";
      }
      for (let i = 0; i < state.allMenuList.color_types.options.length; i++) {
        if (state.allMenuList.color_types.options[i].name == name) {
          return state.allMenuList.color_types.options[i].name_j;
        }
      }
      return "";
    },
    findPaperTypeJName: (state) => (name) => {
      if (!state.allMenuList.paper_types) {
        return "";
      }
      for (let i = 0; i < state.allMenuList.paper_types.options.length; i++) {
        if (state.allMenuList.paper_types.options[i].name == name) {
          return state.allMenuList.paper_types.options[i].name_j;
        }
      }
      return "";
    },
    findMethodsJName: (state) => (name) => {
      for (let i = 0; i < state.allMenuList.methods?.options.length; i++) {
        if (state.allMenuList.methods.options[i].name === name) {
          return state.allMenuList.methods.options[i].name_j;
        }
      }
      return "";
    },
    findPostingStatusJName: (state) => (intNumber) => {
      if (orderStore.getters.orderArray2d === "posting_and_print") {
        return state.findPostingAndPrintStatusJName[intNumber];
      }
      if (state.statusListPosting.length) {
        return state.statusListPosting[intNumber] || "";
      }
      if (intNumber == 0) {
        return "原稿アップロード前";
      } else if (intNumber == 1) {
        return "依頼内容確認・原稿審査中";
      } else if (intNumber == 2) {
        return "原稿審査完了・トラッキング番号の入力";
      } else if (intNumber == 3) {
        return "配布依頼中";
      } else if (intNumber == 4) {
        return "配布報告完了待ち";
      } else if (intNumber == 5) {
        return "配布報告完了済み";
      } else if (intNumber == 6) {
        return "原稿審査承認 NG";
      } else if (intNumber == 7) {
        return "原稿フォーマットNG";
      } else if (intNumber == 8) {
        return "キャンセル";
      } else {
        return "";
      }
    },
    findOrikomiStatusJName: (state) => (intNumber) => {
      if (state.statusListOrikomi.length) {
        return state.statusListOrikomi[intNumber] || "";
      }
      if (intNumber == 0) {
        return "原稿審査承認前";
      } else if (intNumber == 1) {
        return "原稿審査確認中";
      } else if (intNumber == 2) {
        return "原稿審査承認済";
      } else if (intNumber == 3) {
        return "折込依頼中";
      } else if (intNumber == 4) {
        return "折込完了報告済";
      } else if (intNumber == 5) {
        return "原稿審査承認NG";
      } else if (intNumber == 6) {
        return "原稿フォーマットNG";
      } else if (intNumber == 7) {
        return "注文キャンセル";
      } else {
        return "";
      }
    },

    findDemographicsName: (state) => (intNumber) => {
      if (state.demographicsLists.length) {
        return state.demographicsLists.filter((data) => data.id == intNumber)[0]
          .target_name;
      }
    },
    allDemographics: (state) => () => {
      if (state.demographicsLists.length) {
        let data = [];

        for (let i = 1; i <= state.demographicsLists.length; i++) {
          data.push(state.demographicsLists[i - 1].target_name);
        }
        return data;
      }
    },
    allDays: (state) => () => {
      if (state.daysLists.length) {
        let data = [];

        for (let i = 1; i <= state.daysLists.length; i++) {
          data.push(state.daysLists[i - 1].target_name);
        }
        return data;
      }
    },
    allOs: (state) => () => {
      if (state.osLists.length) {
        let data = [];

        for (let i = 1; i <= state.osLists.length; i++) {
          data.push(state.osLists[i - 1].target_name);
        }
        return data;
      }
    },
    allHours: (state) => () => {
      if (state.hoursLists.length) {
        let data = [];

        for (let i = 1; i <= state.hoursLists.length; i++) {
          data.push(state.hoursLists[i - 1].target_name);
        }
        return data;
      }
    },

    findDaysName: (state) => (intNumber) => {
      if (state.daysLists.length) {
        return state.daysLists.filter((data) => data.id == intNumber)[0]
          .target_name;
      }
    },
    findOsName: (state) => (intNumber) => {
      if (state.osLists.length) {
        return state.osLists.filter((data) => data.id == intNumber)[0]
          .target_name;
      }
    },
    findHoursName: (state) => (intNumber) => {
      if (state.hoursLists.length) {
        return state.hoursLists.filter((data) => data.id == intNumber)[0]
          .target_name;
      }
    },
    findGeenieStatusJName: (state) => (intNumber) => {
      "配信登録済",
        "配信データ承認待",
        "配信データ承認済",
        "配信中",
        "配信完了報告待",
        "配信報告完了済",
        "原稿審査承認NG",
        "キャンセル";
      if (state.statusListGeenie.length) {
        return state.statusListGeenie[intNumber] || "";
      }

      if (intNumber == 0) {
        return "配信登録済";
      } else if (intNumber == 1) {
        return "配信データ承認待";
      } else if (intNumber == 2) {
        return "配信データ承認済";
      } else if (intNumber == 3) {
        return "配信中";
      } else if (intNumber == 4) {
        return "配信完了報告待";
      } else if (intNumber == 5) {
        return "配信報告完了済";
      } else if (intNumber == 6) {
        return "原稿審査承認 NG";
      } else if (intNumber == 7) {
        return "キャンセル";
      } else {
        return "";
      }
    },
    findPrintStatusJName: (state) => (intNumber) => {
      if (state.statusListPostingAndPrint.length) {
        return state.statusListPostingAndPrint[intNumber] || "";
      }
      if (intNumber == 0) {
        return "印刷データ承認前";
      } else if (intNumber == 1) {
        return "印刷データ確認中";
      } else if (intNumber == 2) {
        return "印刷データ承認済";
      } else if (intNumber == 3) {
        return "印刷中";
      } else if (intNumber == 4) {
        return "発送済";
      } else if (intNumber == 5) {
        return "到着済";
      } else if (intNumber == 6) {
        return "原稿審査承認NG";
      } else if (intNumber == 7) {
        return "キャンセル";
      } else {
        return "";
      }
    },
    findAreaLevelJName: (state) => (areaLevel) => {
      if (areaLevel == "town") {
        return "町丁目";
      } else if (areaLevel == "municipality") {
        return "市区町村";
      }
    },
  },

  plugins: [createPersistedState()],
});

export { allMenuStore };
